import { Profile } from '../common/Profile'
import { capWord } from '@src/utils/capWord'

export function formatProfileFirstLastName(profile: Profile) {
  const firstName = profile.firstName ? capWord(profile.firstName) : ''
  const lastName = profile.lastName ? capWord(profile.lastName) : ''
  return `${firstName} ${lastName}`
}